export default __webpack_public_path__ + "static/Natural_Light_Outdoor_5120kbps-edff05de9acc12cebf2968776a00462f.avif";